import React, { useState } from "react"
import { useLocation } from "react-router-dom"
import ReactGA from "react-ga"


const GATracker = (trackingId, isTracking=false, isDev=false) => {
    const location = useLocation()
    const [initialized, setInitialized] = useState(false);

    React.useEffect(() => {
        if ((!window.location.href.includes("localhost")) && isTracking) {
            ReactGA.initialize(trackingId, { debug: isDev })
            
            setInitialized(true);
        }
    }, [])

    React.useEffect(() => {
        if (initialized) {
            const currentPath = location.pathname + location.search

            ReactGA.set({ page: currentPath })
            ReactGA.pageview(currentPath)
        }
    }, [initialized, location])

    return null;
}

export default GATracker;